import {
  FavouriteNotificationPreferenceUpdateRequestType,
  FavouriteNotificationPreferenceUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFavouriteNotificationPreferenceUpdate = (
  favouriteNotificationPreferenceId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: FavouriteNotificationPreferenceUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `favourite-notification-preference/${favouriteNotificationPreferenceId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as FavouriteNotificationPreferenceUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.FavouriteNotificationPreferences,
        ],
      });
    },
  });
};
